const CONSTANTS = require("./metadata");

const MAPS = CONSTANTS.MAPS

function getMapList(raceCount) {

  const mapList = []

  if (raceCount === 16) {
    for (let i = 0; i < MAPS.length; i++) {
      let races = MAPS[i].races

      for (let j = 0; j < races.length; j++) {
        mapList.push(races[j])
      }
    }
  }
  else {
    let mapCounter = 0
    for (let i = 0; i < MAPS.length; i++) {
      let races = MAPS[i].races

      for (let j = 0; j < races.length; j++) {
        mapList.push(races[j])
        mapCounter++
        if (mapCounter === 15) { break }
      }
    }
    mapList.push(
      {
        "id": 0,
        "name": "Select Map",
        "url": "map_names/SelectMap.png",
        "mapImage": "maps/NoMapSelected.png",
      }
    )
    mapList.push(MAPS[3].races[3])
    mapList.push(MAPS[3].races[3])
  }

  return mapList
}


module.exports.getMapList = getMapList;
